export default __webpack_public_path__ + "static/media/policy02_2023.2ab9f631.jpg";